export interface ILoginWithPhoneRequest {
  type: LoginType;
  otpCode: string;
  otpRefCode: string;
  phone: string;
}

export interface ILoginWithGoogleRequest {
  type: LoginType;
  googleAccessToken: string;
}

export interface ILoginResponse {
  data: ILoggedInData;
  timestamp: string;
}

export interface ILoginVerifyRequest extends IOTPRequest {}

export interface ISignUpRequest extends ISignUpVerifyRequest {
  otpCode: string;
  otpRefCode: string;
  vendorName: string;
}

export interface ISignUpVerifyRequest {
  provinceNameArr: string[];
  districtNameArr: string[];
  vehicleTypeArr: string[];
  businessTypeArr: string[];

  firstname: string;
  lastname: string;
  citizenId: string;
  phone: string;
  email?: string;
  referrerCode: string;
  isAcceptedTerm: boolean;
  vendorName: string;
}

export interface SignUpVerifyRequest {
  province_id?: string[];
  district_id?: string[];
  rider_type?: string[];
  interested_company_id?: string[];

  first_name_th: string;
  last_name_th: string;
  citizen_id: string;
  tel: string;
  referCode?: string;
  isAcceptedTerm: boolean;
  vendorName: string;
}

export enum LoginType {
  PHONE = 'phone',
  GOOGLE = 'google',
}

export enum VendorName {
  All_Now = 'All Now',
}

export interface IOTPRequest {
  phone: string;
}

export interface OTPRequest {
  phone: string;
}

export interface IOTPResponse {
  data: IOTP;
  timestamp: string;
}

export interface OTPResponse {
  status: string;
  message: string;
  otpRefcode: string;
  expiredAt: string; //old
  expired: string;
}

interface IOTP {
  msg: string;
  otpRefCode: string;
  expiredAt: string;
  phone: string;
  otpDigit: number;
  expired: string;
}

class IVendorResponseData {
  name!: string;
}

export class IVendorResponse {
  status!: string;
  data!: IVendorResponseData;
  timestamp!: string;
}

interface ILoggedInData {
  token: string;
  refreshToken: string;
  googleId?: string;
  googleProfile?: { email?: string };
  userId: string;
}

export interface LoggedInData {
  token: string;
  userId: string;
  potentialLeadId: string;
  tel?: string;
}

export interface IRequestHeader {
  authorization?: string | null;
  apiKey?: string;
  projectId?: string;
  companyId?: string;
  idToken?: string;
  responseType?: string;
}

interface IGoogleProfile {
  email: string;
}

interface ILinkGoogle {
  googleAccessToken: string;
  otpRefCode: string;
  googleId: string;
  googleProfile: IGoogleProfile;
}

export interface ILinkGoogleResponse {
  data: ILinkGoogle;
  timestamp: string;
}

export class GetVendorRequest {
  name?: string;
}
